export class DataGridButton {
    constructor(textContent, icon, clickHandler, addClass) {
        this.clickHandler = clickHandler;
        this.addClass = addClass;
        this.render = this.render.bind(this);
        this.textContent = textContent;
        this.icon = icon;
    }
    render() {
        let button = document.createElement('button');
        button.classList.add('dwc-datagrid-btn');
        if (this.addClass) {
            button.classList.add(this.addClass);
        }
        let btnTop = document.createElement('div');
        btnTop.classList.add('dwc_dg_button_top');
        if (this.icon) {
            let iconSpan = document.createElement('span');
            iconSpan.classList.add('dwc_dg_button_icon');
            iconSpan.innerHTML = this.icon;
            btnTop.appendChild(iconSpan);
        }
        let textSpan = document.createElement('span');
        textSpan.classList.add('dwc_dg_button_text');
        textSpan.textContent = this.textContent;
        btnTop.appendChild(textSpan);
        button.appendChild(btnTop);
        if (this.clickHandler) {
            button.addEventListener('click', this.clickHandler);
        }
        return button;
    }
}
